import { GridSize, GridSpacing } from '@material-ui/core/Grid';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import * as React from 'react';
import Masonry from 'react-masonry-css';

interface StylesProps {
    spacing: GridSpacing;
    forceMarginBottom: boolean;
}

const useStyles = makeStyles(theme => ({
    masonryColumn: (props: StylesProps) => ({
        '& > *': {
            marginBottom: `${theme.spacing(props.spacing)}px${props.forceMarginBottom ? ' !important' : ''}`,
        },
        backgroundClip: 'padding-box',
        paddingLeft: theme.spacing(props.spacing),
    }),
    masonryGrid: (props: StylesProps) => ({
        display: 'flex',
        marginLeft: theme.spacing(-props.spacing),
        width: 'inherit',
    }),
    root: {
        margin: theme.spacing(3, 0, 2, 0),
    },
}));

type ColType = Breakpoint;
type ColSize = Exclude<GridSize, 'auto'>;

export type DSMasonryGridColSizes = {
    [key in ColType]?: ColSize;
};

export interface DSMasonryGridProps extends DSMasonryGridColSizes {
    children?: React.ReactNode;
    spacing?: GridSpacing;
    forceMarginBottom?: boolean;
}

export const DSMasonryGrid: React.FC<DSMasonryGridProps> = ({
    children,
    forceMarginBottom = false,
    spacing = 1,
    xs = 1,
    ...props
}) => {
    const {
        sm = xs,
        md = sm,
        lg = md,
        xl = lg,
    } = props;

    const classes = useStyles({ forceMarginBottom, spacing });
    const theme = useTheme();

    const breakpointCols = {
        default: xl,
        [theme.breakpoints.values.xl]: xl,
        [theme.breakpoints.values.lg]: lg,
        [theme.breakpoints.values.md]: md,
        [theme.breakpoints.values.sm]: sm,
        [theme.breakpoints.values.xs]: xs,
    };

    return (
        <Masonry
            breakpointCols={breakpointCols}
            className={classes.masonryGrid}
            columnClassName={classes.masonryColumn}
        >
            {children}
        </Masonry>
    );
};

DSMasonryGrid.displayName = 'DSMasonryGrid';
